var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-5a)", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" },
      React.createElement("path", { d: "M1 18H5C6.10457 18 7 18.8954 7 20V33C7 34.1046 6.10457 35 5 35H1M7 20H13.6667C14.5321 20 15.3743 20.2807 16.0667 20.8L24.8634 27.3975C26.0434 28.2826 26.2826 29.9566 25.3975 31.1366V31.1366C24.5967 32.2044 23.1306 32.517 21.9639 31.8688L15 28" }),
      React.createElement("path", { d: "M7 33L16.5634 37.184C20.6419 38.9683 25.3022 38.8489 29.2839 36.858L37.526 32.737C38.4294 32.2853 39 31.362 39 30.352V30.352C39 28.6372 37.4048 27.3681 35.7339 27.7537L26 30M35 25V13M13 17V13M23.4453 1.3698L9.83205 10.4453C9.37252 10.7517 9.24835 11.3725 9.5547 11.8321L10.4355 13.1532C10.7456 13.6185 11.377 13.739 11.8367 13.4207L23.4308 5.39407C23.7732 5.15699 24.2268 5.15699 24.5692 5.39407L36.1633 13.4207C36.623 13.739 37.2544 13.6185 37.5645 13.1532L38.4453 11.8321C38.7517 11.3725 38.6275 10.7517 38.1679 10.4453L24.5547 1.3698C24.2188 1.14587 23.7812 1.14587 23.4453 1.3698zM30 4.5V2C30 1.44772 30.4477 1 31 1H34C34.5523 1 35 1.44772 35 2V8" }),
      React.createElement("path", { d: "M18 17.778C18 14.5869 20.6863 12 24 12C27.3137 12 30 14.5869 30 17.778C30 20.0829 28.5985 22.0727 26.5714 23" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-5a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H40V40H0z" })
      )
    )
  );
});